import { Box, Skeleton, Stack } from '@mui/material';
import React from 'react';

const BoxItemSkeleton: React.FC = () => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      py: 1.5,
      '&:not(:first-of-type)': {
        borderTop: 1,
        borderColor: 'divider',
      },
    }}
  >
    <Box sx={{ minWidth: 0, flex: 1 }}>
      <Stack spacing={0.75}>
        <Skeleton variant="rounded" width={56} height={20} sx={{ borderRadius: 1 }} />
        <Skeleton variant="text" width="70%" height={20} />
        <Skeleton variant="text" width="50%" height={16} />
      </Stack>
    </Box>
    <Skeleton
      variant="text"
      width={64}
      height={20}
      sx={{ flexShrink: 0, ml: 2 }}
    />
  </Box>
);

export default BoxItemSkeleton;
